import React from "react";
import StudyRoutes from "components/routes/StudyRoutes";

const StudyHome = () => {
  return <StudyRoutes />;
};

export default StudyHome;
